import { Link as MuiLink } from '@mui/material';
import { createLink } from '@tanstack/react-router';

export const RouterLink = createLink(MuiLink);
